//Tabela de cultivar
export class logValveRepository {
  constructor(api) {
    this.api = api
  }
  async showFirstRecordByTable(TABLE) {
    const table = "`LOG_ACTUATOR`.`" + TABLE + "`";
    const raw = `SELECT TIME FROM ${table} ORDER BY 'TIME' ASC LIMIT 1;`
    return await this.api.sql({
      data: {
        sql: raw
      }
    })

  }

}
